export const bubbleMessage1 = 'AmTrav is designed to make managing travel programs and planning business travel easy and fun!'; // eslint-disable-line

export const bubbleMessage2 = "You're just a step away from making your team happier and more productive."; // eslint-disable-line

export const introMessage1 = 'Want access to our award winning booking tool NOW? Complete our short registration process and you’re up and running in minutes.'; // eslint-disable-line

export const introMessage2 = 'Just one last step before you are up and running!';

export const amtravHome = 'https://www.amtrav.com/';
